import { useEffect, useRef } from "react";

import "./Linker.css";

const makeLink = (fn: string) =>
  `https://duckduckgo.com/?q=!%20site:support.google.com/docs/answer%20google%20sheets%20${fn}`;

export function Linker() {
  const rendered = useRef(false);

  useEffect(() => {
    if (rendered.current) return;
    rendered.current = true;

    // extremely cursed "find the external link" style...
    const extLink = document.querySelector("a.chakra-link[target='_blank']")!;
    console.log(extLink.className);

    document
      .querySelectorAll(
        "code[data-language='gsheets'] span:not([data-line=''])",
      )
      .forEach((el) => {
        const rawInnerText = (el as HTMLSpanElement).innerText;
        const innerText = rawInnerText.trim();
        const prefixText = rawInnerText.replace(innerText, "");

        if (innerText && /^[A-Z][A-Z0-9_.]*$/.test(innerText)) {
          const wrapper = document.createElement("span");

          const prefix = document.createElement("span");
          prefix.textContent = prefixText;
          wrapper.appendChild(prefix);

          const link = document.createElement("a");
          link.href = makeLink(innerText);
          link.target = "_blank";
          link.rel = "noopener noreferrer";
          link.className = `${extLink.className} remove-after-icon`;

          const linkInner = el.cloneNode(true);
          linkInner.textContent = innerText;
          link.appendChild(linkInner);

          wrapper.appendChild(link);

          el.replaceWith(wrapper);
        }
      });
  }, []);

  return <></>;
}
